export default {
  form: {
    header: "Module data",
    title: "Optional title",
    module: "Module",
    submodule: "Related",
    device: "Web/Mobile",
    is_active: "Show on wall",
    selectmodule: "Select module",
    selectsubmodule: "Select related",
    material: "Material",
    materials: "Materials",
    selectmaterial: "Select material",
    use_workbook_cover: "Use workbook cover",
    tag: "Tag",
    for_ceo: "For CEO",
    bg_border: "Background border",
    headers: {
      info: "Arrange the order of sections on wall",
    },
    tabs: {
      web: "Web",
      mobile: "Mobile",
      normal: "Normal",
      ceo: "CEO",
    },
    buttons: {
      saveData: "Save changes",
      addData: "Add item",
      cancel: "Cancel",
    },
  },
};
